var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mx-3" },
            [
              _c(
                "v-tabs",
                {
                  staticClass: "no-transition",
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    "v-tab",
                    {
                      key: "i-users-by-app-version",
                      on: {
                        click: function ($event) {
                          return _vm.updateActiveTab("i-users-by-app-version")
                        },
                      },
                    },
                    [
                      _vm._v("Users by app version "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { size: "20" },
                        },
                        [_vm._v("mdi-alert-rhombus-outline")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab",
                    {
                      key: "i-users-by-package-id",
                      on: {
                        click: function ($event) {
                          return _vm.updateActiveTab("i-users-by-package-id")
                        },
                      },
                    },
                    [
                      _vm._v("Users by package Id "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { size: "20" },
                        },
                        [_vm._v("mdi-package-variant")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mx-3 mt-2" },
            [
              _c(
                "v-card",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { width: "100%", elevation: "0" },
                },
                [
                  _c(
                    "v-card-actions",
                    { staticClass: "ma-0 pa-0" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c(
                            "v-tabs-items",
                            {
                              staticClass: "mt-0",
                              model: {
                                value: _vm.tab,
                                callback: function ($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab",
                              },
                            },
                            [
                              _c(
                                "v-tab-item",
                                {
                                  key: "i-users-by-app-version",
                                  attrs: {
                                    transition: "fade-transition",
                                    "reverse-transition": "fade-transition",
                                  },
                                },
                                [
                                  _c("i-users-by-app-version", {
                                    ref: "i-users-by-app-version",
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                {
                                  key: "i-users-by-package-id",
                                  attrs: {
                                    transition: "fade-transition",
                                    "reverse-transition": "fade-transition",
                                  },
                                },
                                [
                                  _c("i-users-by-package-id", {
                                    ref: "i-users-by-package-id",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }